import { render, staticRenderFns } from "./UpdatePayGrade.vue?vue&type=template&id=cf9fb206"
import script from "./UpdatePayGrade.vue?vue&type=script&lang=js"
export * from "./UpdatePayGrade.vue?vue&type=script&lang=js"
import style0 from "./UpdatePayGrade.vue?vue&type=style&index=0&id=cf9fb206&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports